<template>
  <div class="cont">
  <div class="toutu">
    <img src="../../assets/yanwoshipu.jpg"></div>
  <div class="div_t">
    <div>
	<span class="ypsp" style="text-align: center; display: block;">燕窝食谱</span><br>
	<br style="overflow-wrap: break-word; margin: 0px; padding: 0px; color: rgb(51, 51, 51); font-family: 微软雅黑; text-align: center;">
	<span style="color:#ffcb8d;"><span style="display: block; overflow-wrap: break-word; margin: 0px; padding: 0px; font-family: 微软雅黑; text-align: center; font-size: 16px;"><span style="overflow-wrap: break-word; margin: 0px; padding: 0px;white-space: nowrap;">—————————————————————————————————————————————————————</span></span></span><br>
	<div class="shipu_hang" style="margin-top: 35px;">
		<div class="sp_hang_left">
			<img class="sp_img" src="../../assets/1-1Z5291A640Y5.jpg"> <span class="sp_title">青橄榄炖燕窝</span>
			<div class="sp_txt">
				材料：青橄榄、燕窝<br>
				做法：青橄榄切半，与燕窝放进炖盅内，隔水慢炖20分钟，最后5分钟加入冰糖即可。</div>
		</div>
		<div class="sp_hang_right">
			<img class="sp_img" src="../../assets/1-1Z5291FJ5H9.jpg"> <span class="sp_title">星空燕窝</span>
			<div class="sp_txt">
				材料：燕窝，黑枸杞，石蜂糖<br>
				做法：在杯子中加入石峰糖、炖好的燕窝，再加入黑枸杞，轻轻搅拌黑枸杞下色。</div>
		</div>
	</div>
	<div class="shipu_hang">
		<div class="sp_hang_left">
			<img class="sp_img" src="../../assets/1-1Z5291GT2G5.jpg"> <span class="sp_title">水果燕窝</span>
			<div class="sp_txt">
				材料：燕窝3-5克，自己喜欢的水果适量<br>
				做法：炖好的燕窝放凉，加入自己喜欢的水果，清清爽爽，夏日必备。</div>
		</div>
		<div class="sp_hang_right">
			<img class="sp_img" src="../../assets/1-1Z5291P155216.jpg"> <span class="sp_title">红枣燕窝</span>
			<div class="sp_txt">
				材料：红枣、燕窝<br>
				做法：将红枣洗净和泡发好的燕窝一起放入炖盅，隔水炖煮30分钟即可，可根据个人口味加入适量冰糖。</div>
		</div>
	</div>
	<div class="shipu_hang">
		<div class="sp_hang_left">
			<img class="sp_img" src="../../assets/1-1Z5291K101O5.jpg"> <span class="sp_title">玫瑰花燕窝</span>
			<div class="sp_txt">
				材料：燕窝3-5克，玫瑰花、冰糖适量<br>
				做法：玫瑰花以80°以内的水温先泡好，以冰糖或 蜜糖调味。燕窝炖好后放到碗里，加上玫瑰花茶， 即可食用。</div>
		</div>
		<div class="sp_hang_right">
			<img class="sp_img" src="../../assets/1-1Z5291KT0H8.jpg"> <span class="sp_title">木瓜牛奶燕窝</span>
			<div class="sp_txt">
				材料：木瓜、牛奶、燕窝、冰糖<br>
				做法：牛奶加冰糖小火慢熬至冰糖融化，加入炖好的燕窝和切好的木瓜即可。</div>
		</div>
	</div>
	<div class="shipu_hang">
		<div class="sp_hang_left" style="height: 474px;">
			<img class="sp_img" src="../../assets/1-1Z5291P144Q2.jpg"> <span class="sp_title">燕窝鸡蛋羹</span>
			<div class="sp_txt">
				材料：鸡蛋、燕窝<br>
				做法：燕窝炖好备用，鸡蛋在容器里搅拌均匀， 加入炖好的燕窝并搅拌均匀，放入炖锅炖煮十分 钟，一碗营养丰富的燕窝鸡蛋羹就完成了。</div>
		</div>
		<div class="sp_hang_right" style="height: 474px;">
			<img class="sp_img" src="../../assets/1-1Z5291GT2G5.jpg"> <span class="sp_title">牛油果燕窝</span>
			<div class="sp_txt">
				材料：新鲜牛油果、燕窝、薄荷叶、冰糖少许<br>
				做法：牛油果对半切，取出果肉放入器皿中，并碾碎。在炖好的燕窝中加入冰糖，燕窝盛出后放入之前碾碎的牛油果可以了。</div>
		</div>
	</div>
</div>
<br>

  </div>
 
</div>

</template>

<script>
	
export default {
  name: 'forumYpsp',
  data () {
    return {
      
    }
  },
  methods:{
			
		}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.toutu {
    width: 1120px;
    margin: auto;
}
.ypsp{ font-size: 26px;}
.toutu img {
    width: 100%;
}

.cont {
    width: 1120px;
    margin: 0 auto;
    height: 100%;

}

.logo {
    margin-left: 449px;
    margin-top: 72px;
}


.div_t_div {
    width: 1120px;
    height: 500px;
    position: relative;
}

.div_t_div_img1 {
    width: 500px;
    position: absolute;
}

.div_t_div_img2 {
    position: absolute;
    margin-left: 400px;
    top: 62px;
    z-index: 1;
    height: 280px;
    width: 700px;
}

.text1 {
    position: absolute;
    margin-left: 580px;
    top: 94px;
    z-index: 3;
    width: 500px;
}

.text1 li {
    display: block;
    font-size: 26px;
    letter-spacing: 3px;
    color: #1b1b1b;
    margin-left: 0px;
}

.hrs {
    height: 1px;
    border: none;
    border-top: 1px solid #35b597;
    width: 426px;
    margin-left: 0px;
    margin-top: 16px;
    float: left;
}

.text1_p {
    font-size: 16px;
    text-indent: 2em;
    float: right;
    margin-right: 50px;
    margin-top: 10px;
    line-height: 39px;
    color: #1b1b1b;
    letter-spacing: 1px;
}

.div_c {
    width: 1120px;
    margin: 0 auto;
    margin-top: 0px;
    height: 500px;
    position: relative;
}

.div_c_img1 {
    width: 500px;
    margin-left: 620px;
    position: absolute
}

.div_c_img2 {
    position: absolute;
    top: 50px;
    z-index: 1;
    height: 280px;
    margin-left: 50px;
    width: 700px;
}

.text2 {
    position: absolute;
    /*margin-left: 100px;*/
    top: 82px;
    z-index: 3;
    width: 500px;
}

.text2_li {
    display: block;
    font-size: 26px;
    letter-spacing: 5px;
    color: #1b1b1b;
}

.text2_p {
        font-size: 16px;
    text-indent: 2.3em;
    line-height: 39px;
    color: #1b1b1b;
    margin-top: 32px;
    margin-left: 0px;
    letter-spacing: 3px;
}
.shipu_hang {
    margin-top: 80px;
    /* margin-bottom: 20px; */
    height: 459px;
    width: 945px;
    margin-left: auto;
    margin-right: auto;
}
.sp_hang_left {
    float: left;
    width: 430px;
    height: 443px;
    box-shadow: 2px 3px 10px #999;
}
.sp_hang_right {
    float: right;
    width: 430px;
    height: 443px;
    box-shadow: 2px 3px 10px #999;
}
.sp_img {
    width: 430px;
    height: 266px;
    display: block;
}
.sp_title {
    font-size: 18px;
    color: #daa520;
    height: 67px;
    line-height: 79px;
    border-bottom: 1px solid #daa520;
    display: block;
    padding-left: 15px;
}
.sp_txt {
    height: 40px;
    line-height: 28px;
    padding-top: 15px;
    font-size: 16px;
    color: #444;
    padding-left: 15px;
    padding-right: 8px;
}
@media(max-width: 750px) {
   .cont{width:100%; margin: 0 auto;}
   .toutu{ width: 100%; overflow: hidden}
   .toutu img{ width: 100%; margin-left: 0%;}
  .div_t{ width: 690px; margin: 30px auto;}
  .ypsp{ font-size: 32px;}
  table{ width:690px;}
  .pic{ height:280px;}
  .spantext{ font-size: 24px}
 .shipu_hang{ width: 690px;}
 .sp_hang_left,.sp_hang_right{ width: 48%; height: 470px;}
 .sp_img{ width: 100%; height: 200px;}
 .shipu_hang{ margin-top: 35px;height: 470px;}
 .sp_title{ font-size: 30px;}
 .sp_txt{ height: auto; font-size: 24px; overflow : hidden; text-align: left; padding:0 15px; margin-top: 15px;
text-overflow: ellipsis;
display: -webkit-box;
-webkit-line-clamp: 5;
-webkit-box-orient: vertical;}
}     
</style>



// WEBPACK FOOTER //
// src/components/forum/ypsp.vue